"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGames = void 0;
var keys_1 = require("../keys");
var react_1 = require("react");
var useMutation_1 = require("../useMutation");
var useGetGames = function (_a) {
    var _b = _a === void 0 ? {} : _a, variables = _b.variables;
    var _c = (0, useMutation_1.useMutation)({
        path: keys_1.GAMES,
    }), mutate = _c.mutate, data = _c.data, error = _c.error, isSubmitting = _c.isSubmitting;
    (0, react_1.useEffect)(function () {
        mutate(__assign({}, variables));
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        getGames: mutate,
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isSubmitting,
        error: error,
    }); }, [data, mutate, isSubmitting, error]);
};
exports.useGetGames = useGetGames;
